// @flow
import React, {useContext} from 'react';

import type {Action, State} from './types';

export const DEFAULT_STATE = {
  purchasing: false,
  purchased: false,
  selectedPlan: null,
  promotionCode: null,
  paymentMethod: null,
};

export const CheckoutStateContext: React$Context<?State> = React.createContext<?State>();

export const stateReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_PLAN':
      return {
        ...state,
        promotionCode: null,
        selectedPlan: action.plan,
      };

    case 'APPLY_PROMOTION_CODE':
      return {
        ...state,
        promotionCode: action.promotionCode,
      };

    case 'RESET_PROMOTION_CODE':
      return {
        ...state,
        promotionCode: null,
      };

    case 'SET_PAYMENT_METHOD':
      return {
        ...state,
        paymentMethod: action.paymentMethod,
      };

    case 'SET_PURCHASING':
      return {
        ...state,
        purchasing: action.purchasing,
      };

    case 'COMPLETE_PURCHASE':
      return {
        ...state,
        purchased: true,
      };

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};

export const useCheckoutState = (): State => {
  const state = useContext(CheckoutStateContext);
  if (!state) {
    throw new Error('useCheckoutState must be used within a CheckoutProvider');
  }
  return state;
};
